import {
  RowData,
  JsonSchema,
  JsonSchemaProperty,
  RowDataValueType,
} from "../../../../types";
import { ExcelValidationError } from "../../../../types/types.fileUpload";
import {
  isFieldRequired,
  validateDateField,
  validateString,
  validateNumber,
} from "../../validations";
import { getSchemaSections } from "../schemaHelpers";
import { FIELDS_TO_EXCLUDE } from "./downloadFileUploadTemplate";

export const validateImportedRows = (
  rows: RowData[],
  schema: JsonSchema,
): ExcelValidationError[] => {
  const errors: ExcelValidationError[] = [];
  const fields = getSchemaSections(schema).flatMap(
    (section) => section.sectionValue,
  );

  rows.forEach((row, rowIndex) => {
    fields.forEach((propertyKey) => {
      if (FIELDS_TO_EXCLUDE.has(propertyKey)) return;

      const property = schema.properties?.[propertyKey];
      const message = validateField(propertyKey, property, row[propertyKey]);

      if (message) {
        errors.push({
          rowIndex: rowIndex + 2,
          field: propertyKey,
          message,
        });
      }
    });
  });

  return errors;
};

const validateField = (
  propertyKey: string,
  property: JsonSchemaProperty | undefined,
  value: RowDataValueType,
): string | null => {
  if (!property) {
    return null;
  }

  if (isFieldRequired(propertyKey, property, value)) {
    return "This field is Required";
  }

  if (value == null || value === "") {
    return null;
  }

  if (property.format) {
    const result = validateDateField(property.format, value as string);
    if (result.error) return result.message;
  }

  if (typeof value === "string") {
    const result = validateString(property, value);
    if (result.error) return result.message;
  }

  if (typeof value === "number") {
    const result = validateNumber(property, value);
    if (result.error) return result.message;
  }
  if (
    Array.isArray(property.enum) &&
    !property.enum.includes(value as string)
  ) {
    return `Value must be one of: ${property.enum.join(", ")}`;
  }

  return null;
};
